import styled, { CSSProperties, css } from 'styled-components';
import { Position } from '../types/Drawer.types';

type Placement = Record<
  Position,
  Partial<Record<'top' | 'right' | 'bottom' | 'left', 0 | string>>
>;

const transforms: Record<Position, string> = {
  left: 'translateX(-100%)',
  right: 'translateX(100%)',
};
const placements: Placement = {
  left: {
    top: 0,
    bottom: 0,
    left: 0,
  },
  right: {
    top: 0,
    right: 0,
    bottom: 0,
  },
};

const borderRadius: Record<Position, CSSProperties['borderRadius']> = {
  left: '0 6px 6px 0',
  right: '6px 0px 0px 6px',
};

export const DrawerWrapper = styled.div<{
  position: Position;
  open: boolean;
  size: string;
}>`
  position: absolute;
`;

export const DrawerOverlay = styled.div<{ open: boolean }>`
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  z-index: 999;
  background: rgba(13, 13, 13, 0.3);
  display: ${props => (props.open ? null : 'none')};
`;

export const DrawerContent = styled.div<{
  position: Position;
  open: boolean;
  size: string;
  backgroundColor: string;
  direction: 'ltr' | 'rtl';
}>`
  border-radius: ${props => borderRadius[props.position]};
  width: ${props => props.size};
  max-width: 90%;
  color: #000;
  box-shadow: ${props =>
    props.open ? '-10px 0px 10px rgba(0, 0, 0, 0.19)' : 'none'};
  background-color: ${props => props.backgroundColor || '#fff'};

  ${props =>
    props.direction === 'rtl' &&
    css`
      flex-direction: row-reverse;
      text-align: start;
    `}

  position: fixed;
  ${props => placements[props.position]}

  z-index: 9999;

  transform: ${props =>
    !props.open ? transforms[props.position] : 'translateX(0)'};
  transition: transform 0.2s ease-out;
  
  overflow-y: scroll;
  ${props =>
    !props.open &&
    css`
      overflow-x: hidden;
    `}    
`;
